module.exports = __webpack_public_path__ + "static/006.thumb-3f533ccbcfe7cb6b04ea9011e9462bbc.jpg";